import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { DetailedHTMLProps, FC, HTMLAttributes, useState } from "react";

import { RichText } from "../../rich-text";
import { PortraitCardInner } from "./portrait-card-inner";

const variants = {
  visible: {
    y: 0,
  },
  invisible: {
    y: "100%",
  },
};

export interface PortraitCardProps
  extends Queries.PortraitCardDataFragment,
    Pick<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "className"> {}

export const PortraitCard: FC<PortraitCardProps> = ({
  titleLine1,
  titleLine2,
  subtitle,
  description,
  image,
  className,
}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div className={clsx(["flex rounded-lg overflow-hidden relative", className])}>
      {image?.gatsbyImageData && (
        <GatsbyImage
          image={image.gatsbyImageData}
          objectFit="cover"
          className="w-full aspect-[280/330]"
          alt=""
        />
      )}

      <div
        className="flex flex-col h-full w-full rounded-lg overflow-hidden absolute z-10"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        {/* real visible component */}
        <PortraitCardInner
          {...{ titleLine1, titleLine2, subtitle }}
          className="absolute z-20 bottom-0 left-0 w-full"
          isHover={!!description?.raw && isHover}
        >
          <AnimatePresence initial={false}>
            {isHover && (
              <motion.div
                className="absolute top-0 left-0"
                key="child"
                variants={variants}
                initial="invisible"
                animate="visible"
                exit="invisible"
                transition={{
                  y: { ease: "easeOut", duration: 0.4 },
                }}
              >
                <div className="flex w-full flex-col justify-stretch px-4 pb-6">
                  <RichText
                    className="font-light text-light line-clamp-[10]"
                    raw={description?.raw}
                  />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </PortraitCardInner>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment PortraitCardData on ContentfulPortraitCard {
    __typename
    titleLine1
    titleLine2
    subtitle
    description {
      raw
    }
    image {
      gatsbyImageData
    }
  }
`;
